// extracted by mini-css-extract-plugin
export default {"Filter":"Anschlagbrett_Filter__z2Fyd"};